"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var button = document.querySelector(".button");
var messageWin = document.querySelector(".message-win");
var messageLose = document.querySelector(".message-lose");
var messageStart = document.querySelector(".message-start");
var fieldRows = document.querySelectorAll(".field-row");
var gameScore = document.querySelector(".game-score");
var size = 4;
var score = 0;
var isWin = false;
var newGameField;
var gameField = [
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0
    ]
];
// eslint-disable-next-line no-shadow
var move = function(event) {
    newGameField = _to_consumable_array(gameField);
    switch(event.key){
        case "ArrowLeft":
            left(newGameField);
            break;
        case "ArrowRight":
            right(newGameField);
            break;
        case "ArrowDown":
            down(newGameField);
            break;
        case "ArrowUp":
            up(newGameField);
            break;
        default:
            return;
    }
    for(var row = 0; row < size; row++){
        for(var col = 0; col < size; col++)if (newGameField[row][col] !== gameField[row][col]) {
            gameField = newGameField;
            addNumber();
            render();
        }
    }
    if (isWin) messageWin.classList.remove("hidden");
    if (!isPosibleToMove()) {
        messageLose.classList.remove("hidden");
        document.removeEventListener("keydown", move);
    }
};
button.addEventListener("click", function() {
    document.addEventListener("keydown", move);
    if (button.classList.contains("start")) {
        button.classList.replace("start", "restart");
        button.innerText = "Restart";
        messageStart.classList.add("hidden");
    } else {
        isWin = false;
        reset();
    }
    addNumber();
    addNumber();
    render();
});
function checkRows() {
    var hasDuplicates = false;
    newGameField.forEach(function(row) {
        if (row.some(function(cell, index) {
            return cell === 0 || cell === row[index + 1];
        })) hasDuplicates = true;
    });
    return hasDuplicates;
}
function checkColumns() {
    var hasDuplicates = false;
    newGameField.forEach(function(row) {
        row.forEach(function(cell, index) {
            if (cell === row[index + 1]) hasDuplicates = true;
        });
    });
    return hasDuplicates;
}
function reverseRows() {
    newGameField.forEach(function(row) {
        return row.reverse();
    });
}
function transposeGameField() {
    newGameField = newGameField[0].map(function(x, colIndex) {
        return newGameField.map(function(row) {
            return row[colIndex];
        });
    });
}
function findEmptyCell() {
    var emptyCells = [];
    gameField.forEach(function(row, rowIndex) {
        row.forEach(function(cell, columnIndex) {
            if (cell === 0) emptyCells.push([
                rowIndex,
                columnIndex
            ]);
        });
    });
    return emptyCells[Math.floor(Math.random() * emptyCells.length)];
}
function isPosibleToMove() {
    if (checkRows()) return true;
    transposeGameField();
    return checkColumns();
}
var addNumber = function() {
    var _findEmptyCell = _sliced_to_array(findEmptyCell(), 2), randomX = _findEmptyCell[0], randomY = _findEmptyCell[1];
    gameField[randomX][randomY] = Math.random() < 0.9 ? 2 : 4;
};
var left = function() {
    if (!checkRows) return;
    newGameField = newGameField.map(function(row) {
        var newRow = row.filter(function(cell) {
            return cell !== 0;
        });
        newRow.forEach(function(cell, index) {
            if (cell === newRow[index + 1]) {
                newRow[index] *= 2;
                newRow.splice(index + 1, 1);
                score += newRow[index];
                if (newRow[index] === 2048) isWin = true;
            }
        });
        return newRow.concat(Array(size - newRow.length).fill(0));
    });
};
var right = function() {
    if (!checkRows) return;
    reverseRows();
    left();
    reverseRows();
};
var down = function() {
    transposeGameField();
    right();
    transposeGameField();
};
var up = function() {
    transposeGameField();
    left();
    transposeGameField();
};
var render = function() {
    gameField.forEach(function(row, rowIndex) {
        row.forEach(function(cell, colIndex) {
            var elem = fieldRows[rowIndex].children[colIndex];
            if (cell === 0) {
                elem.textContent = "";
                elem.className = "field-cell";
            } else {
                elem.textContent = cell;
                elem.className = "field-cell field-cell--".concat(cell);
            }
        });
    });
    gameScore.textContent = score;
};
var reset = function() {
    score = 0;
    gameField = [
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ],
        [
            0,
            0,
            0,
            0
        ]
    ];
    if (!messageLose.classList.contains("hidden")) messageLose.classList.add("hidden");
    if (!messageWin.classList.contains("hidden")) messageWin.classList.add("hidden");
};

//# sourceMappingURL=index.a0ba03db.js.map
